export const WinelistsDisplayComponent = {
  template: require('./winelists-display.component.jade'),
  bindings: {
    venue: '<'
  }
};
